import Vue from 'vue';

// default tags
import btn from '@/components/elements/btn';

Vue.component('btn', btn);
